import LceCourseExperienceExperiments from 'bundles/epic/clients/LceCourseExperience';

/**
 * A feature flag to guard the injectable activity UI during development and testing.
 * @returns true if https://tools.coursera.org/epic/experiment/xem6tABXEfGgRA4nU0VIYQ is enabled.
 */
export const isActivityInjectionUiEnabled = (): boolean => {
  return LceCourseExperienceExperiments.preview('isActivityInjectionUiEnabled') === true;
};

/**
 * A feature flag to guard the injectable activity API during development and testing.
 * @returns true if https://tools.coursera.org/epic/experiment/Co8USRjMEfGAfhJYNo68EQ is enabled.
 */
export const isActivityInjectionApiEnabled = (): boolean => {
  return LceCourseExperienceExperiments.preview('isActivityInjectionApiEnabled') === true;
};

/**
 * An A/B/C test to determine the variant of the activity injection.
 * https://tools.coursera.org/epic/experiment/mrH-ZQk8EfGgRA4nU0VIYQ
 * @returns the variant of the activity injection OR undefined if the user is not targeted for the experiment.
 */
export type ActivityInjectionVariant = ReturnType<typeof LceCourseExperienceExperiments.preview<'practiceMoment'>>;
export const previewActivityInjectionVariant = (): ActivityInjectionVariant => {
  return LceCourseExperienceExperiments.preview('practiceMoment');
};
export const impressActivityInjectionVariant = (): ActivityInjectionVariant => {
  return LceCourseExperienceExperiments.get('practiceMoment');
};

/**
 * EPIC: https://tools.coursera.org/epic/experiment/k98dJpsQEfC-lAr_4rnFJw
 * This experiment is "ended" (rollout 0), but keeping this around for easy internal access to Phase 1 for testing purposes.
 */
export const isCourseFrameRevertToPhase1Enabled = (): boolean => {
  return LceCourseExperienceExperiments.preview('isCourseFrameRevertToPhase1Enabled') === true;
};

/**
 * EPIC: https://tools.coursera.org/epic/experiment/zpXu_M_oEfCgRA4nU0VIYQ
 * @returns true if phase 3 should be shown in the UI.
 */
export const isCourseFramePhase3Enabled = (): boolean => {
  return LceCourseExperienceExperiments.preview('isCourseFramePhase3Enabled') === true;
};

/**
 * @returns true if the tool panel should be shown instead of inline tabs.
 */
export const isToolPanelEnabled = (): boolean => {
  return LceCourseExperienceExperiments.get('isToolPanelEnabled') === true;
};

/**
 * @returns true if the 2026 course frame styles should be applied.
 */
export const is2026CourseFrameStylesEnabled = (): boolean => {
  return LceCourseExperienceExperiments.get('is2026CourseFrameStylesEnabled') === true;
};
